import { DragDropButton } from '@/components/gantt/dragDrop/DragDropButton';
import { ItemTypes } from '@/components/gantt/dragDrop/types';
import { itemTypeToColor } from '@/helpers/dailyHelper';
import { useGetTaskIcon, useTasks } from '@/services/tasks/useTasks';
import { FC } from 'react';
import { BsCupFill } from 'react-icons/bs';
import strings from '../roster/roster.translations';

export const TemplateTaskButtons: FC = () => {
  const tasks = useTasks();
  const getTaskIcon = useGetTaskIcon();

  return (
    <div className="space-y-2">
      <div className="font-semibold">{strings.drawer.tasks.direction}</div>
      <div className="flex gap-3 flex-wrap">
        <DragDropButton
          name={strings.drawer.tasks.break}
          Icon={BsCupFill}
          color={itemTypeToColor(ItemTypes.BREAK)}
          textColor="white"
          item={{ type: ItemTypes.BREAK }}
        />
        {tasks.map(task => (
          <DragDropButton
            key={task.id}
            name={task.name}
            Icon={getTaskIcon(task.id)}
            color={task.color}
            textColor={task.textColor}
            item={{ type: ItemTypes.TASK, context: task.id }}
          />
        ))}
      </div>
    </div>
  );
};
